import {Grid } from '@material-ui/core'
import React, { useState, useRef,useEffect } from 'react';
import './addPrivacyPolicy.css'
import Controls from '../../scenes/global/controls/Controls'
import JoditEditor from 'jodit-react';
import axios from 'axios';
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function AddPrivacyPolicy({ placeholder }) {

    const editor = useRef(null);
	const [content, setContent] = useState('');
	const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

   
    useEffect(() => {
     
        axios
          .get(`${BaseUrl}/api/privacyPolicy`)
          .then((res) => {
            setContent(res.data.data.content);
            setNotes(res.data.data.notes);
          })
    },[])
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
      const bodyFormData = new FormData();
      bodyFormData.append("content", content);
      bodyFormData.append("notes", notes);
      axios
      .post(`${BaseUrl}/api/addPrivacyPolicy`, bodyFormData, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status === true) {
          setLoading(false);
          sweetalert("تم إضافة سياسة الخصوصية بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
        },
        );
        } else {
          setLoading(false);
          sweetalert("حدث خطأ ما", {
            className: "alert-div",
            button: {
              text: "تم",
            },
        },
        );
    
        
        }
      });
        
    }

  return (
    <div className="main-div">
    <form className="form-group new-design" method="post"
        enctype="multipart/form-data" onSubmit={handleSubmit}>
         <h3 className="titlepage">إضافة سياسة الخصوصية</h3>
         <div className="editor">
         <JoditEditor
			ref={editor}
			value={content}
			
			tabIndex={13} 
			onBlur={newContent => setContent(newContent)} 
			onChange={newContent => {}}
		/>
          
        </div>
         <h3 className="titlepage">إضافة ملاحظات</h3>
         <div className="editor">
         <JoditEditor
			ref={editor}
			value={notes}
			tabIndex={3} 
			onBlur={newContent => setNotes(newContent)} 
			onChange={newContent => {}}
		/>
        </div>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
        {loading === true ? (
            <Controls.Button
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
          <Controls.Button
            type="submit"
            text="حفظ"
            variant="contained"
            className="btn-submit"
          ></Controls.Button>
          )}
        </Grid>
    </form>
    </div>
  )
}

export default AddPrivacyPolicy